import React from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import MeetingMain from 'flow/components/meeting/shared/MeetingMain';
import { LocationType } from 'flow/types/Location';
import { ChatConferenceParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

const ChatMeeting = () => {
    const { id: chatSessionKey } = useParams<ChatConferenceParams>();
    const history = useHistory<LocationType>();

    const onClickBack = () => {
        history.push(
            history.location.state?.from
                ? history.location.state.from
                : generatePath(routes['messages.id'], {
                      id: chatSessionKey,
                  }),
        );
    };

    return (
        <MeetingMain
            meetingLobbyKey={chatSessionKey}
            onClickBack={onClickBack}
            allowToggleNewMembers={false}
        />
    );
};

export default ChatMeeting;
